var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTinTuc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 28.5714C0.333496 12.7919 13.1254 0 28.9049 0H71.7621C87.5416 0 100.333 12.7919 100.333 28.5714V71.4286C100.333 87.2081 87.5416 100 71.7621 100H28.9049C13.1254 100 0.333496 87.2081 0.333496 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1193 62.6968V30.3665C77.1193 27.1522 74.4943 24.7683 71.3068 25.0361H71.1461C65.5211 25.5183 56.9764 28.3843 52.2086 31.3843L51.7532 31.679C50.9764 32.1611 49.6907 32.1611 48.9139 31.679L48.2443 31.2772C43.4764 28.304 34.9586 25.4647 29.3336 25.0093C26.1461 24.7415 23.5479 27.1522 23.5479 30.3397V62.6968C23.5479 65.2683 25.6371 67.679 28.2086 68.0004L28.9854 68.1076C34.7979 68.8843 43.7711 71.8308 48.9139 74.6433L49.0211 74.6968C49.7443 75.0986 50.8961 75.0986 51.5925 74.6968C56.7353 71.8576 65.7353 68.8843 71.5746 68.1076L72.4586 68.0004C75.03 67.679 77.1193 65.2683 77.1193 62.6968Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.334 32.5632V72.7418",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9496 40.5989H32.9229",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9586 48.6345H32.9229",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_877",
    x1: 0.333496,
    y1: 50,
    x2: 100.333,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E502A"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTinTuc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TinTuc.342bbd95.svg";
export { ForwardRef as ReactComponent };